import { render, staticRenderFns } from "./CarouselSlots.vue?vue&type=template&id=219bbd54&scoped=true"
import script from "./CarouselSlots.vue?vue&type=script&lang=js"
export * from "./CarouselSlots.vue?vue&type=script&lang=js"
import style0 from "./CarouselSlots.vue?vue&type=style&index=0&id=219bbd54&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219bbd54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('219bbd54')) {
      api.createRecord('219bbd54', component.options)
    } else {
      api.reload('219bbd54', component.options)
    }
    module.hot.accept("./CarouselSlots.vue?vue&type=template&id=219bbd54&scoped=true", function () {
      api.rerender('219bbd54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/theme/CarouselSlots.vue"
export default component.exports